import { render, staticRenderFns } from "./FiltroComparativo.vue?vue&type=template&id=139195f4"
import script from "./FiltroComparativo.vue?vue&type=script&lang=js"
export * from "./FiltroComparativo.vue?vue&type=script&lang=js"
import style0 from "./FiltroComparativo.vue?vue&type=style&index=0&id=139195f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports